import styled from "styled-components"

export const MainContent = styled.main<{ $isPrivilege?: boolean }>`
  max-width: ${({ $isPrivilege }) => ($isPrivilege ? "90%" : "980px")};
  margin: 0 auto;
`
